"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e="dental21-server-sent-event";exports.SERVER_SENT_EVENT_KEY=e;
